import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
export var NotFound = function () {
    var _a;
    var t = useTranslation(['news']).t;
    var langCode = ((_a = document.getElementById("language-code")) === null || _a === void 0 ? void 0 : _a.value) || "en";
    var urlNews = langCode == "fr" ? "/fr/nouvelles/" : "/en/news/";
    return (_jsx(React.Fragment, { children: _jsxs("div", { className: "not-found-container", children: [_jsxs("div", { className: "content", children: [_jsxs("div", { className: "title mt-2 me-0", children: [" ", t("Aucun résultat de recherche"), " "] }), _jsx("p", { className: "mt-2", children: t("Malheureusement il n'y a pas de résultat selon votre demande. Veuillez essayer un mot-clé.") })] }), _jsxs("a", { className: "btn btn-primary mt-5 me-0", href: urlNews, children: [" ", t("Dernières nouvelles"), " "] })] }) }));
};
